import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { OrderListPage } from "@/modules/order";
import { requireAuthAndPermission } from "@/utils";

const orderListSearchSchema = z.object({
  status: fallback(
    z.enum([
      "all",
      "order_created",
      "waiting_for_payment",
      "paid",
      "failed",
      "done"
    ]),
    "all"
  ).default("all"),
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  start_date: fallback(
    z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: "start_date must be in YYYY-MM-DD format"
    }),
    ""
  ).default(""),
  end_date: fallback(
    z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: "end_date must be in YYYY-MM-DD format"
    }),
    ""
  ).default("")
});

export const Route = createFileRoute("/orders/")({
  validateSearch: zodValidator(orderListSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Orders"
        description="View and manage your customer orders."
      />
      <OrderListPage />
    </>
  )
});

export type OrderListSearchSchema = z.infer<typeof orderListSearchSchema>;
